// eslint-disable-next-line max-lines-per-function
define( [ 'utility', 'blocks/o-modal' ], function run( utility, modal ) {
	'use strict';

	var aContextHelpFn = {

		contentLengthLimit : 175,

		init : function( elmOriginal ) {
			var parentSplit,
				elm = document.createElement( 'button' ); // Splitting point within element parent innerHTML

			if ( !elmOriginal.classList.contains( 'js-a-context-help' ) ) {
				elmOriginal.classList.add( 'js-a-context-help' );

				Array.from( elmOriginal.attributes ).forEach( function loop( node ) {
					elm.setAttributeNode( node.cloneNode( true ) );
				});

				elm.setAttribute( 'type', 'button' );
				elm.innerHTML = elmOriginal.innerHTML;
				elmOriginal.parentNode.replaceChild( elm, elmOriginal );

				elm.aContextHelp = {};

				elm.aContextHelp.parent = elm.parentNode;
				elm.aContextHelp.formrow = false;

				if ( elm.classList.contains( 'm-form-row__explanatory-text' ) ) {
					aContextHelpFn.formrow( elm );
				} else {
					parentSplit = elm.aContextHelp.parent.innerHTML.split( '</span></button>' );
					if ( typeof parentSplit[ 1 ] !== 'undefined' ) {
						if ( parentSplit[ 1 ].match( /[a-zA-Z0-9]+/g ) ) {
							elm.setAttribute( 'data-variant', 'modal' );
						}
					}

					elm.aContextHelp.targetHref = elm.getAttribute( 'href' ).substring( 1 );
					elm.aContextHelp.content = document.getElementById( elm.aContextHelp.targetHref );
					elm.aContextHelp.trimmedContent = elm.aContextHelp.content.textContent.replace( /[\t\n\r]+/g, '' );
					elm.aContextHelp.contentLength = elm.aContextHelp.trimmedContent.length;
					elm.aContextHelp.trigger = elm;
				}

				// Check variant and setup for modal if required
				if ( elm.getAttribute( 'data-variant' ) === 'modal' || elm.aContextHelp.contentLength > aContextHelpFn.contentLengthLimit ) {
					aContextHelpFn.modal( elm );
				} else {
					aContextHelpFn.standard( elm );
				}

				elm.aContextHelp.close = function close() {
					if ( elm.getAttribute( 'data-variant' ) === 'modal' || elm.aContextHelp.contentLength > aContextHelpFn.contentLengthLimit ) {
						if ( elm.aContextHelp.modalInstance ) {
							elm.aContextHelp.modalInstance.close();
						}
					} else {
						aContextHelpFn.closeStandard( elm );
					}
				};
			}

			return elm.aContextHelp;
		},

		formrow : function( elm ) {
			var id = elm.id, // Element ID
				label, // Label within element parent
				labelOuter, // Wrapping div for label element
				elInnerHTML, // Element innerHtML
				accessibleText; // Hidden accessible text for screen readers

			if ( elm.getAttribute( 'data-accessible-text' ) && elm.getAttribute( 'data-accessible-text' ) !== '' ) {
				accessibleText = elm.getAttribute( 'data-accessible-text' );
			} else {
				accessibleText = FRAMEWORK.locale.settings.aContextHelp.formText;
			}

			elm.removeAttribute( 'id' );

			// Add icon and link to trigger (label / legend)
			label = elm.aContextHelp.parent.querySelector( '.a-label' );
			if ( label.nodeName === 'LABEL' ) {
				labelOuter = utility.htmlStringToElement( '<div class="' + label.getAttribute( 'class' ) + '"></div>' ); // Create new wrapping element
				utility.wrap( label, labelOuter ); // Wrap label in new wrapper
				label.removeAttribute( 'class' ); // Remove any classes that were on the original label
			} else if ( label.nodeName === 'LEGEND' ) {
				labelOuter = utility.htmlStringToElement( '<div class="' + label.getAttribute( 'class' ) + '"><span aria-hidden="true">' +
				label.innerHTML + '</span></div>' ); // Create visual label element
				label.insertAdjacentElement( 'afterend', labelOuter ); // Insert visible label after legend
				label.classList.add( 'u-hidden--visually' ); // Visually hide the original legend
			} else {
				labelOuter = label;
			}

			elm.aContextHelp.trigger = utility.htmlStringToElement( '<button class="a-context-help js-a-context-help a-link-icon a-context-help--hidden-text" href="#' + id +
				'"><span class="a-context-help__link a-link-icon__inner u-hidden--visually">' + accessibleText + '</span><span class="a-context-help__icon"></span></button>' );
			labelOuter.append( elm.aContextHelp.trigger );

			// Setup html in preparation
			elInnerHTML = elm.innerHTML;
			elm.aContextHelp.wrapper = utility.htmlStringToElement( '<div class="a-context-help-wrapper t-accent-light" id="' + id +
				'" style="display: none"><p class="a-context-help-wrapper__text">' + elInnerHTML + '</p></div>' );
			elm.insertAdjacentElement( 'afterend', elm.aContextHelp.wrapper );

			elm.aContextHelp.content = document.getElementById( elm.aContextHelp.targetHref );
			elm.aContextHelp.length = elm.textContent.length;
			elm.remove();
			elm.aContextHelp.formrow = true;
		},

		standard : function( elm ) {
			var elWrapperInnerHTML,
				elWrapperInner, // Element wrapper
				text, // Element inner text element
				heading, // Context help heading element
				closeDuplicate, // Duplicated close element
				cursor, // Cursor element
				cursorPos, // Cursor element bounding rectangle
				onResizeRefresh, // Resize / refresh function
				wrapperClose; // Wrapper close button


			if ( elm.aContextHelp.formrow === true ) {
				// Just get wrapper and inner divs, as form row pre-processor has already set up tooltip and content
				elm.aContextHelp.wrapperAdditions = '<div class="a-context-help-inner"><span class="a-context-help-wrapper__ui"></span>' + elm.aContextHelp.wrapper.innerHTML +
					'<button class="a-button a-button--tertiary a-button--close a-context-help-wrapper__close" type="button"><span class="a-button__inner">' +
					FRAMEWORK.locale.settings.aContextHelp.closeText + '</span></button></div>';
				elm.aContextHelp.wrapper.innerHTML = elm.aContextHelp.wrapperAdditions;
				elm.aContextHelp.inner = elm.aContextHelp.wrapper.querySelector( '.a-context-help-inner' );
			} else {
				elm.aContextHelp.linkInner = elm.querySelector( '.a-link-icon__inner' );
				if ( elm.aContextHelp.linkInner.classList.contains( 'u-hidden--visually' ) ) {
					elm.classList.add( 'a-context-help--hidden-text' );
				}

				elm.aContextHelp.linkInner.classList.add( 'a-context-help__link' );

				// Set up tooltip, insert content from elsewhere on page and remove original content
				elm.aContextHelp.wrapper = utility.htmlStringToElement( elm.aContextHelp.content.outerHTML );
				elm.aContextHelp.parent.insertAdjacentElement( 'afterend', elm.aContextHelp.wrapper );
				elm.aContextHelp.wrapper.classList.remove( 'a-context-help-content' );
				elm.aContextHelp.wrapper.classList.add( 'a-context-help-wrapper' );
				elm.aContextHelp.wrapper.classList.add( 't-accent-light' );
				elm.aContextHelp.wrapper.style.display = 'none';
				elm.aContextHelp.wrapper.setAttribute( 'aria-hidden', 'true' );
				elm.aContextHelp.content.remove();

				// Wrap inner content and hide visually ready to transition in when active
				elWrapperInnerHTML = elm.aContextHelp.wrapper.innerHTML;
				elWrapperInner = '<div class="a-context-help-inner"><span class="a-context-help-wrapper__ui"></span>' + elWrapperInnerHTML +
					'<button class="a-button a-button--tertiary a-button--close a-context-help-wrapper__close" type="button"><span class="a-button__inner">' +
					FRAMEWORK.locale.settings.aContextHelp.closeText + '</span></button></div>';
				elm.aContextHelp.wrapper.innerHTML = elWrapperInner;
				elm.aContextHelp.inner = elm.aContextHelp.wrapper.querySelector( '.a-context-help-inner' );

				text = elm.aContextHelp.inner.querySelector( '.a-context-help-content__text' );
				text.classList.remove( 'a-context-help-content__text' );
				text.classList.add( 'a-context-help-wrapper__text' );

				// Remove unneeded heading
				heading = elm.aContextHelp.inner.querySelector( '.a-context-help-content__heading' );
				heading.remove();

				elm.aContextHelp.iconElement = document.createElement( 'span' );
				elm.aContextHelp.iconElement.classList.add( 'a-context-help__icon' );
				elm.append( elm.aContextHelp.iconElement );
			}

			closeDuplicate = elm.aContextHelp.wrapper.querySelector( '.a-context-help-inner + .a-context-help-wrapper__close' );
			if ( closeDuplicate ) {
				closeDuplicate.remove();
			}
			elm.aContextHelp.trigger.setAttribute( 'aria-controls', elm.aContextHelp.wrapper.getAttribute( 'id' ) );
			elm.aContextHelp.trigger.setAttribute( 'aria-expanded', 'false' );

			cursor = document.createElement( 'span' );
			cursor.classList.add( 'cursor' );
			elm.aContextHelp.trigger.insertBefore( cursor, elm.aContextHelp.iconElement );
			cursorPos = cursor.getBoundingClientRect();
			elm.aContextHelp.cursorLeft = cursorPos.left;
			cursor.remove();

			// Break line if necessary, then centre triangle under icon
			aContextHelpFn.breakLine( elm );
			aContextHelpFn.centreTriangle( elm );

			// Resize/refresh function
			onResizeRefresh = utility.debounce( function listener() {
				aContextHelpFn.breakLine( elm );
				aContextHelpFn.centreTriangle( elm );
			}, 10 );
			window.addEventListener( 'resize', onResizeRefresh );

			// Create refresh event and associated eventListener
			window.addEventListener( 'refresh', onResizeRefresh, false );

			// Function for main trigger
			elm.aContextHelp.triggerActive = false;
			elm.aContextHelp.trigger.addEventListener( 'click', function listener( e ) {
				e.preventDefault();
				if ( elm.aContextHelp.triggerActive === false ) {
					elm.aContextHelp.triggerActive = true;
					if ( elm.aContextHelp.trigger.classList.contains( 'a-context-help--active' ) ) {
						elm.aContextHelp.trigger.classList.remove( 'a-context-help--active' );
						elm.aContextHelp.trigger.setAttribute( 'aria-expanded', 'false' );
					} else {
						elm.aContextHelp.trigger.classList.add( 'a-context-help--active' );
						elm.aContextHelp.trigger.setAttribute( 'aria-expanded', 'true' );
					}
					utility.slideToggle( elm.aContextHelp.wrapper, FRAMEWORK.timings.current.t350ms, {
						callback : function() {
							elm.aContextHelp.triggerActive = false;
						},
					});
					if ( elm.aContextHelp.inner.classList.contains( 'a-context-help-inner--active' ) ) {
						elm.aContextHelp.inner.classList.remove( 'a-context-help-inner--active' );
					} else {
						elm.aContextHelp.inner.classList.add( 'a-context-help-inner--active' );
					}
				} else {
					// Do nothing - triggerActive is true, so click is disbled until animation has completed
				}
			});

			// Function for close button within element
			wrapperClose = elm.aContextHelp.wrapper.querySelector( '.a-context-help-wrapper__close' );
			wrapperClose.addEventListener( 'click', function listener( e ) {
				e.preventDefault();

				aContextHelpFn.closeStandard( elm, function callbackFn() {
					elm.aContextHelp.trigger.focus();
				});
			}, false );
		},

		closeStandard : function( elm, callback ) {
			var closeFunc = function closeFunc() {
					if ( elm.aContextHelp.trigger.classList.contains( 'a-context-help--active' ) ) {
						elm.aContextHelp.triggerActive = true;
						elm.aContextHelp.trigger.classList.remove( 'a-context-help--active' );
						elm.aContextHelp.trigger.setAttribute( 'aria-expanded', 'false' );
						utility.slideToggle( elm.aContextHelp.wrapper, FRAMEWORK.timings.current.t350ms, {
							variant : 'up',
							callback : function() {
								elm.aContextHelp.triggerActive = false;
								if ( typeof callback === 'function' ) {
									callback();
								}
							},
						});
						elm.aContextHelp.inner.classList.remove( 'a-context-help-inner--active' );
					}
				},
				interval;

			if ( elm.aContextHelp.triggerActive ) {
				interval = setInterval( function intervalFn() {
					if ( elm.aContextHelp.triggerActive ) {
						// Do nothing just wait
					} else {
						clearInterval( interval );
						closeFunc();
					}
				}, 50 );
			} else {
				closeFunc();
			}
		},

		modal : function( elm ) {
			var onResizeRefresh; // Resize/refresh function

			// Set up modal
			if ( elm.aContextHelp.formrow === true ) {
				elm.aContextHelp.trigger.querySelector( '.a-link-icon__inner' ).classList.add( 'a-context-help__link' );
				elm.aContextHelp.trigger.setAttribute( 'data-module', 'o-modal' );
				elm.aContextHelp.wrapper.classList.add( 'o-modal__content-container' );
			} else {
				elm.querySelector( '.a-link-icon__inner' ).classList.add( 'a-context-help__link' );
				elm.setAttribute( 'data-module', 'o-modal' );
				elm.aContextHelp.content.classList.add( 'o-modal__content-container' );
			}

			elm.aContextHelp.iconElement = document.createElement( 'span' );
			elm.aContextHelp.iconElement.classList.add( 'a-context-help__icon' );
			elm.append( elm.aContextHelp.iconElement );

			// Break line if necessary
			aContextHelpFn.breakLine( elm );

			// Resize/refresh function
			onResizeRefresh = utility.debounce( function listener() {
				aContextHelpFn.breakLine( elm );
			}, 10 );
			window.addEventListener( 'resize', onResizeRefresh );

			// Create refresh event and associated eventListener
			window.addEventListener( 'refresh', onResizeRefresh, false );

			// Initialise modal instance
			elm.aContextHelp.modalInstance = modal.initInstance();
		},

		breakLine : function( elm ) {
			var triggerParent = elm.aContextHelp.trigger.parentNode, // Trigger parent
				breaker = triggerParent.querySelector( 'br' ), // Line break within trigger parent
				indentLeft, // Element left indent
				parentPos, // Position of triggerParent's parent
				parentWidth, // TriggerParent's parent's width
				wrapperLink, // Trigger link
				breakText, // WrapperLink innerHTML
				breakTextFlag, // BreakText variant
				breakWords, // BreakText split
				lastWord, // Last word
				joinWords; // Joined back text

			if ( breaker ) {
				breaker.remove();
			}

			// Work out if line break is necessary...
			indentLeft = aContextHelpFn.getCursorPos( elm ) + 36; /* Indent + icon width + left padding */

			if ( triggerParent.tagName === 'LEGEND' ) {
				parentPos = triggerParent.parentNode.getBoundingClientRect();
			} else {
				parentPos = triggerParent.getBoundingClientRect();
			}
			parentWidth = parentPos.width;
			wrapperLink = elm.aContextHelp.trigger.querySelector( '.a-context-help__link' );

			// ...and break the line as required (indent > than parent's width / icon is at the extreme left of the parent's bounding box (icons with no supporting text content)
			if ( ( indentLeft > parentWidth || indentLeft === 36 ) && !triggerParent.classList.contains( 'm-showhide__contextual-help-container' ) ) {
				// Break the line before the last word
				breakText = wrapperLink.innerHTML;
				breakTextFlag = 'content';

				if ( elm.aContextHelp.trigger.classList.contains( 'a-context-help--hidden-text' ) ) {
					// Trigger has no text content attached, so get text from wrapperLink (form) or parent (other cases)
					elm.aContextHelp.trigger.remove();
					if ( elm.aContextHelp.formrow === true ) {
						breakText = triggerParent.innerHTML;
						breakTextFlag = 'form';
					} else {
						breakText = elm.aContextHelp.parent.innerHTML;
						breakTextFlag = 'parent';
					}
				} else {
					// Inner link has text content, so already have it
				}

				// Split, add break...
				breakWords = breakText.trim().split( ' ' );
				lastWord = ' <br />' + breakWords.pop();
				joinWords = breakWords.join( ' ' ) + lastWord;

				// ...and reassemble
				if ( breakTextFlag === 'form' ) {
					// Add recreated text + original element back into parent link
					triggerParent.innerHTML = joinWords;
					triggerParent.append( elm.aContextHelp.trigger );
				} else if ( breakTextFlag === 'parent' ) {
					// Add recreated text + original element back into parent link
					elm.aContextHelp.parent.innerHTML = joinWords;
					elm.aContextHelp.parent.append( elm );
				} else {
					// Flag is 'content', so just add recreated text back into link
					wrapperLink.innerHTML = joinWords;
				}
			}
		},

		getCursorPos : function( elm ) {
			var parentPos,
				parentLeft,
				iconElement,
				cursor,
				cursorPos,
				cursorLeft,
				indent;

			cursor = document.createElement( 'span' );
			cursor.classList.add( 'cursor' );
			iconElement = elm.aContextHelp.trigger.querySelector( '.a-context-help__icon' );
			elm.aContextHelp.trigger.insertBefore( cursor, iconElement );
			parentPos = elm.aContextHelp.trigger.parentNode.getBoundingClientRect();
			parentLeft = parentPos.left;
			cursor = elm.aContextHelp.trigger.querySelector( '.cursor' );
			cursorPos = cursor.getBoundingClientRect();
			cursorLeft = cursorPos.left;
			indent = Number.parseInt( cursorLeft - parentLeft, 10 );
			cursor.remove();

			return indent;
		},

		centreTriangle : function( elm ) {
			var correction = 12, /* Correction required to pull triangle in from the right */
				wrapperUI = elm.aContextHelp.wrapper.querySelector( '.a-context-help-wrapper__ui' ),
				wrapperUIleft = aContextHelpFn.getCursorPos( elm ) + correction;
			wrapperUI.style.left = wrapperUIleft + 'px';
		},
	};

	return {
		initInstance : function( elmOriginal ) {
			return aContextHelpFn.init( elmOriginal );
		},
	};
});
